import { Routes, Route } from 'react-router-dom';
import Categories from './components/Categories/Categories';
import ProductDetail from './components/ProductDetail/ProductDetail';
import HomePage from './components/HomePage/HomePage';
import Products from './components/Products/Products';
import CategoryDetail from './components/CategoryDetail/CategoryDetail';
import ContactButtons from './components/ContactButtons/ContactButtons';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

function App() {
  return (
    <>
      {/* 1. Sayfa her değiştiğinde en üste atsın kanka */}
      <ScrollToTop />

      {/* 2. İletişim butonları (WhatsApp, Telefon vb.) tüm sayfalarda sabit */}
      <ContactButtons />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/kategoriler" element={<Categories />} />
        {/* Lot No (T803 vb.) üzerinden detay sayfasına uçuyoruz */}
        <Route path="/urun/:productId" element={<ProductDetail />} />               
        <Route path="/urunler" element={<Products />} />
        {/* Kategori slug'ı üzerinden listelemeye uçuyoruz */}
        <Route path="/kategori/:slug" element={<CategoryDetail />} />
      </Routes>
    </>
  );
}

export default App;